import { schema } from "normalizr";

export const gallerySchema = new schema.Entity("gallery", {});

export const galleriesSchema = new schema.Array(gallerySchema);
